import { AvailableEntityBackendKeys } from '~/helpers/formatters';

const COHORTS_ROUTE = '/cohorts';
export const ENTITY_KEY: AvailableEntityBackendKeys = 'Cohort';

export const COHORTS_ROUTES = {
  root: COHORTS_ROUTE,
  edit: [`${COHORTS_ROUTE}/new`, `${COHORTS_ROUTE}/:id`]
};
